import api from "./api";

export interface IOperario {
    asig_id: number;
    cedula: string;
    fecha: string;
    fechainicio: string;
    legajo: string;
    op_id: number;
    operario: string;
    ps_id: number;
    telefono: string;
    total_horas: string;
}

export interface IOperariosResponse {
    codigo: string;
    fecha: string;
    nombre: string;
    operarios: IOperario[];
}

type FetchCierreDiarioOperariosOptions = {
    // modo=todos: devuelve operarios asignados del PS en la fecha (aunque no haya "no corresponde").
    // Si no se envía, se mantiene el comportamiento legacy (solo "no corresponde").
    modo?: string;
};

export const fetchCierreDiarioOperarios = async (
    ps_id: number,
    fecha: string,
    options?: FetchCierreDiarioOperariosOptions
): Promise<IOperariosResponse> => {
    try {
        const response = await api.get(`/cierre_diario/operarios_asignados/${ps_id}/${fecha}`, {
            params: {
                modo: options?.modo,
            },
        });
        const data = response.data.datos as IOperariosResponse;
        return data;
    } catch (error) {
        console.error('Error al obtener los operarios:', error);
        throw error;
    }
}
